import "./Login.css";
import { useNavigate } from "react-router-dom";
import logo from "../../images/logo_biojeck.png";
import { useState } from "react";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const API_URL = process.env.REACT_APP_API_URL;

  const handleLogin = () => {
    setErrorMessage(""); // Limpiar mensaje de error
    const data = { username, password };

    fetch(`${API_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.result) {
          console.log(result.result);
          
          if (result.result[0].state_employee === "INACTIVO") {
            setErrorMessage(
              "Este usuario se encuentra inactivo, por favor contactarse con el administrador"
            );
          } else {
            // Guardar usuario y actualizar autenticación
            localStorage.setItem("user", JSON.stringify(result.result));
            onLogin(); // Actualizar estado en App
            navigate("/home"); // Redirigir a /home
          }
        } else {
          setErrorMessage("Usuario o contraseña incorrectos.");
        }
      })
      .catch(() => {
        setErrorMessage("Ocurrió un error al iniciar sesión.");
      });
  };

  return (
    <div className="container login d-flex justify-content-center align-items-center min-vh-100">
      <div className="row border rounded-5 p-3 bg-white shadow box-area">
        <div className="col-md-6 col-sm-3 rounded-4 d-flex justify-content-center align-items-center flex-column left-box container-logo">
          <img src={logo} alt="BioJeck Logo" className="img-fluid img-logo" />
        </div>
        <div className="col-md-6 right-box">
          <div className="row align-items-center">
            <div className="mb-4">
              <h2>Hola de nuevo</h2>
              <p>Ingresa tus credenciales para continuar.</p>
            </div>
            {errorMessage && (
              <div className="alert alert-danger p-2 text-center">
                {errorMessage}
              </div>
            )}
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control form-control-lg bg-light fs-6"
                placeholder="Usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value.trim())}
              />
            </div>
            <div className="input-group mb-3">
              <input
                type="password"
                className="form-control form-control-lg bg-light fs-6"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value.trim())}
              />
            </div>
            <div className="input-group mb-3">
              <button onClick={handleLogin} className="btn-lg w-100 btn-login">
                Ingresar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
